<template src="./Index.html" />

<script>
export default {
  components: {

  },
  created() {
    this.getAll();
  },
  computed: {
    summary() {
      return this.$store.state.workDaysClosing.summary;
    },
    period() {
      return [
        { value: 1, label: "صباحية" },
        { value: 2, label: "مسائية" },]
    },

  },
  data() {
    return {
      date: new Date().toISOString().slice(0, 10),

      // summary: {
      //   morningClosing: null,
      //   morningTotal: null,
      //   morningNotes: null,
      //   eveningClosing: null,
      //   eveningTotal: null,
      //   eveningNotes: null,
      // },
      vm: {
        period: null,
        closingAmount: null,
        totalReceived: null,
        remarks: null,
        revenues: null,
        //refunds: null,
      },
      permissions: this.$patientsManagementPermissions.workDaysClosingPermissions,
      showResult: false,
      dialog: false,
      dialogType: null,
      total: {
       // debitTotal: null,
        creditTotal: null,
        // totalPayments: null,
        // totalService: null
      },
      dialogMessage: "",
    };
  },
  methods: {
    getAll() {
      this.$store.dispatch("workDaysClosing/getAll");
    },
    getSummary() {
      this.total = {
        // debitTotal: null,
        creditTotal: null,
        // totalAnalyses: null,
        // totalPayments: null,
        // totalService: null
      };
      this.showResult = false;
      this.$store.dispatch("workDaysClosing/getSummary", this.vm.period).then((res) => {
        if (res != undefined) {

          this.showResult = true;
          this.total = {
          //  debitTotal:  res.debitTotal,
            creditTotal: res.creditTotal,
            // totalAnalyses: res.totalAnalyses,
            // totalPayments: res.totalPayments,
            // totalService: res.totalService
          };
          this.vm.closingAmount = res.creditTotal ; // - res.debitTotal 
          this.vm.revenues = res.creditTotal  ;
         // this.vm.refunds =  res.debitTotal ;
        }
        else{
          this.resetForm();

        }
      })
        .catch((err) => {
          console.log(err)
        });
    },

    confirm() {
      this.$store.dispatch(`workDaysClosing/add`, this.vm);
      this.resetForm();
    },
    print(type) {
      const routeData = this.$router.resolve(`/workDay-print/${type}`);
      window.open(routeData.href, "_blank");
    },
    async saveClosing() {
      if (!this.date || !this.period || !this.closingAmount || !this.totalReceived) {
        alert('يرجى ملء جميع الحقول المطلوبة.');
        return;
      }

      // تحديث ملخص البيانات بناءً على الفترة
      if (this.period === 'صباحية') {
        this.summary.morningClosing = this.closingAmount;
        this.summary.morningTotal = this.totalReceived;
        this.summary.morningNotes = this.notes;
      } else if (this.period === 'مسائية') {
        this.summary.eveningClosing = this.closingAmount;
        this.summary.eveningTotal = this.totalReceived;
        this.summary.eveningNotes = this.notes;
      }

      // تصفية الحقول
      this.resetForm();

    },
    resetForm() {
      this.vm = {
        period: null,
        closingAmount: null,
        totalReceived: null,
        remarks: null,
      };
    },
  },

};
</script>